<template>
  <!-- 关联合同就是项目转合同后会把数据回填在这里 -->
  <div class="contract-chart">
    <div class="contract-table">
      <!-- :edit-rules="tableRules" -->
      <!-- @select-change="handleSelectionChange"
          @select-all="handleSelectionChange"
          @edit-closed="closeEditTableHandler" -->

      <vxe-grid
        border
        show-overflow
        resizable
        ref="serviceFeeRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        :data="tableDataList"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
        >
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  // import BASEAPI from '@/api/dataBase.js';
  import { chartColumns } from './index.js';
  export default {
    name: 'AssoContractChart',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      //customer or supplier
      chartType: {
        type: String,
        default: 'customer',
      },
      serviceTypeName: {
        type: String,
        default: '仓储服务',
      },
      // baseFormData: {
      //   type: Object,
      //   require: true,
      // },
    },
    mounted() {
      console.log('mounted');
      // this.getChartColumns();
      // this.columns = chartColumns;
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        // columns: [],
      };
    },
    computed: {
      columns() {
        return chartColumns(this);
      },
    },
    methods: {
      // getChartColumns() {
      //   let type = this.chartType;
      //   if (type == 'supplier') {
      //     let temp = [];
      //     chartColumns.map(function (item) {
      //       if (type == 'supplier' && item.field === 'customerName') {
      //         var copyItem = {};
      //         copyItem.field = 'supplierName';
      //         copyItem.title = '供方名称';
      //         copyItem.width = '140';
      //         temp.push(copyItem);
      //       } else {
      //         temp.push(item);
      //       }
      //       return item;
      //     });
      //     this.columns = temp;
      //   } else {
      //     this.columns = chartColumns;
      //   }
      // },
    },
  };
</script>

<style lang="scss" scoped>
  .contract-chart {
    background: #fff;

    .contract-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
